import * as bootstrap from "bootstrap";
import {
    CartClassName,
    CartId,
    CartDataAttribute,
    CartItemDataAttribute,
} from "./types";
import { buildCheckoutItemFromCartElement } from "./analytics";

function buildGiftCheckboxMarkup(cartItemId: string, isGift: boolean): string {
    return `
            <div class="form-check form-check-checkbox">
                <input id="confirmGiftPurchaseChk_${cartItemId}" class="form-check-input no-validate js-confirm-gift-purchase" data-${CartItemDataAttribute.CartItemId}="${cartItemId}" type="checkbox" value="" ${isGift ? "checked" : ""}>
                <label class="form-check-label" for="confirmGiftPurchaseChk_${cartItemId}">
                    I'm purchasing this course for someone else
                </label>
            </div>
        `;
}
export function listenToRemoveItemClick() {
    $(`.${CartClassName.RemoveItem}`).on("click", function (e) {
        const cartItemId = $(this).data(CartItemDataAttribute.CartItemId);
        const cartItem = $(this).closest(".wCartWidget__cart-item");
        e.preventDefault();
        SaSpinnerUtils.ShowFullPageSpinner();
        $.ajax({
            type: "post",
            url: "/api/Cart/remove",
            data: { cartItemId: cartItemId },
            success: function (data) {
                if (data.success) {
                    try {
                        SaAnalyticsUtils.addToDataLayer(
                            SaAnalyticsUtils.buildRemoveFromCartEventFromItems([
                                buildCheckoutItemFromCartElement(cartItem),
                            ]),
                        );
                    } catch (error) {
                        console.error(
                            "GA4 remove_from_cart tracking error:",
                            error,
                        );
                    } finally {
                        globalThis.location.reload();
                    }
                } else {
                    SaSpinnerUtils.HideFullPageSpinner();
                }
            },
        });
    });
}
function updateCartTotals(response: SaCartUtils.CartTotalsResponse): void {
    if (!response) {
        return;
    }

    if (response.subtotalText) {
        $(`#${CartId.CartCalculatedSubTotal}`).text(response.subtotalText);
    }

    if (response.memberDiscountText) {
        $(`#${CartId.CartCalculatedMemberDiscount}`).text(
            response.memberDiscountText,
        );
    }

    if (response.totalText) {
        $(`#${CartId.CartCalculatedTotal}`).text(response.totalText);
        $(`#${CartId.CartCalculatedTotalCopy}`).text(response.totalText);
    }

    if (typeof response.itemCount === "number") {
        const itemLabel = response.itemCount === 1 ? "Item" : "Items";
        $(`#${CartId.CartItemCountLabel}`).text(
            `${response.itemCount} ${itemLabel} |`,
        );
    }
}
function updateCheckoutAvailability(): void {
    const hasVisiblePreviousPurchaseAlert = $(
        `.${CartClassName.PreviouslyPurchased}`,
    )
        .toArray()
        .some(function (element) {
            return !$(element).hasClass("d-none");
        });

    const cartIsBlocked = $(`.${CartClassName.CartBlocked}`)
        .toArray()
        .some(function (element) {
            return !$(element).hasClass("d-none");
        });

    $(`#${CartId.BtnCheckout}`).prop(
        "disabled",
        hasVisiblePreviousPurchaseAlert || cartIsBlocked,
    );
}
export function updatePreviousPurchaseState(
    $card: JQuery<HTMLElement> | null = null,
): void {
    const $cards = $card || $(`.${CartClassName.CartItemCard}`);

    $cards.each(function () {
        const $currentCard = $(this);
        const $cartItem = $currentCard.find(`.${CartClassName.CartItem}`);
        const $giftCheckbox = $currentCard.find(
            `.${CartClassName.ConfirmGiftPurchase}`,
        );
        const cartItemId = $cartItem.data(CartItemDataAttribute.CartItemId);

        if (!cartItemId) {
            return;
        }

        const isGift =
            $giftCheckbox.length > 0
                ? $giftCheckbox.is(":checked")
                : String(
                      $cartItem.data(CartItemDataAttribute.IsGift),
                  ).toLowerCase() === "true";

        handleIsGiftUpdate(isGift, cartItemId);

        const $alert = $(
            `.${CartClassName.PreviouslyPurchased}[data-${CartItemDataAttribute.CartItemId}="${cartItemId}"]`,
        );
        if ($alert.length === 0) {
            return;
        }

        const $counter = $currentCard.find(
            `[data-${CartDataAttribute.CartCounter}]`,
        );

        const quantity =
            $counter.length > 0
                ? SaCartUtils.getQuantity($counter)
                : Number($cartItem.data(CartItemDataAttribute.Quantity)) || 1;

        const shouldShowAlert = !isGift && quantity === 1;

        $alert.toggleClass("d-none", !shouldShowAlert);
    });

    updateCheckoutAvailability();
}

function handleIsGiftUpdate(isGift: boolean, cartItemId: number): void {
    const $previouslyPurchasedAlert = $(
        `.${CartClassName.PreviouslyPurchased}[data-${CartItemDataAttribute.CartItemId}="${cartItemId}"]`,
    );
    const $cartBlockedAlert = $(
        `.${CartClassName.CartBlocked}[data-${CartItemDataAttribute.CartItemId}="${cartItemId}"]`,
    );

    if (isGift) {
        if (
            $previouslyPurchasedAlert &&
            !$previouslyPurchasedAlert.hasClass("d-none")
        ) {
            $previouslyPurchasedAlert.addClass("d-none");
        }

        if ($cartBlockedAlert && !$cartBlockedAlert.hasClass("d-none")) {
            $cartBlockedAlert.addClass("d-none");
        }
    } else {
        if ($previouslyPurchasedAlert) {
            $previouslyPurchasedAlert.removeClass("d-none");
        }

        if ($cartBlockedAlert) {
            $cartBlockedAlert.removeClass("d-none");
        }
    }

    updateCheckoutAvailability();
}

// Function to update footer content based on quantity
function updateFooterContent($counter: JQuery<HTMLElement>): void {
    const $quantityDisplay = $counter.find(
        `.${CartClassName.ItemCountDisplay}`,
    );
    const $card = $counter.closest(`.${CartClassName.CartItemCard}`);
    const $footer = $card.find(`.${CartClassName.ItemFooterCopy}`);
    const $summaryFooter = $(`.${CartClassName.OrderSummaryAllocationMessage}`);
    const cartItemId = $counter
        .find(`.${CartClassName.BtnCounterPlus}`)
        .data(CartItemDataAttribute.CartItemId);

    if ($quantityDisplay.length === 0 || $footer.length === 0) return;

    const quantity = globalThis.SaCartUtils.getQuantity($counter);

    if (quantity > 1) {
        $footer.html(
            "Courses can be allocated after purchase via your Scrum Alliance dashboard.",
        );
        $summaryFooter.css("display", "flex");
    } else if (
        $footer.find(`.${CartClassName.ConfirmGiftPurchase}`).length === 0
    ) {
        // Keep existing checkbox markup/state so a gift toggle doesn't get reset.
        const isGift =
            String(
                $card
                    .find(`.${CartClassName.CartItem}`)
                    .data(CartItemDataAttribute.IsGift) ??
                    $card.data(CartItemDataAttribute.IsGift),
            ).toLowerCase() === "true";
        $footer.html(buildGiftCheckboxMarkup(String(cartItemId), isGift));
        $summaryFooter.hide();
    }
}
export function bindCartCounters(): void {
    if (globalThis.SaCartUtils) {
        globalThis.SaCartUtils.bindCounters({
            namespace: `.${CartClassName.CartWidgetQuantity}`,
            counterSelector: `[data-${CartDataAttribute.CartCounter}]`,
            cardSelector: `.${CartClassName.CartItemCard}`,
            itemSelector: `.${CartClassName.CartItem}`,
            giftSelector: `.${CartClassName.ConfirmGiftPurchase}`,
            onQuantityApplied: function ($counter) {
                updateFooterContent($counter);
                updatePreviousPurchaseState(
                    $counter.closest(`.${CartClassName.CartItemCard}`),
                );
                updateBulkAlert();
            },
            onSyncSuccess: function ($counter, quantity, response) {
                updateFooterContent($counter);
                updateCartTotals(response);
                $counter
                    .closest(`.${CartClassName.CartItemCard}`)
                    .find(`.${CartClassName.CartItem}`)
                    .attr("data-quantity", quantity)
                    .data("quantity", quantity);
                updatePreviousPurchaseState(
                    $counter.closest(`.${CartClassName.CartItemCard}`),
                );
                updateBulkAlert();
            },
            onSyncFailed: function ($counter) {
                updateFooterContent($counter);
                updatePreviousPurchaseState(
                    $counter.closest(`.${CartClassName.CartItemCard}`),
                );
                updateBulkAlert();
            },
        });

        $(`[data-${CartDataAttribute.CartCounter}]`).each(function () {
            updateFooterContent($(this));
        });

        updateBulkAlert();
    }
}
export function bindGiftCheckboxes() {
    $(document).on(
        "change",
        `.${CartClassName.ConfirmGiftPurchase}`,
        function () {
            const $checkbox = $(this);
            const $card = $checkbox.closest(`.${CartClassName.CartItemCard}`);
            const isGift = $checkbox.is(":checked");

            $card.attr(`data-${CartItemDataAttribute.IsGift}`, String(isGift));
            $card.data(CartItemDataAttribute.IsGift, isGift);
            $card
                .find(`.${CartClassName.CartItem}`)
                .attr(`data-${CartItemDataAttribute.IsGift}`, String(isGift))
                .data(CartItemDataAttribute.IsGift, isGift);

            updatePreviousPurchaseState($card);
        },
    );
}
function updateBulkAlert() {
    const $bulkAlert = $(`#${CartId.BulkPurchaseAlert}`);
    if ($bulkAlert.length === 0 || !globalThis.SaCartUtils) return;

    let showAlert = false;

    $(`[data-${CartDataAttribute.CartCounter}]`).each(function () {
        const quantity = globalThis.SaCartUtils.getQuantity($(this));

        if (quantity >= 24) {
            showAlert = true;
            return false; // break out of .each()
        }
    });

    if (showAlert) {
        $bulkAlert.addClass("is-visible");
    } else {
        $bulkAlert.removeClass("is-visible");
    }
}
export function listenToPreviouslyPurchasedChanges() {
    $(document).on(
        "change",
        `.${CartClassName.ConfirmGiftPurchase}`,
        function () {
            const cartItemId = $(this).data(CartItemDataAttribute.CartItemId);
            const $alert = $(
                `.${CartClassName.PreviouslyPurchased}[data-${CartItemDataAttribute.CartItemId}="${cartItemId}"]`,
            );

            if (!$alert.length) return;

            if ($(this).is(":checked")) {
                $alert.hide();
            } else {
                $alert.show();
            }
        },
    );
}
export function initPopovers() {
    // Init once
    document.querySelectorAll('[data-bs-toggle="popover"]').forEach((el) => {
        const existing = bootstrap.Popover.getInstance(el);
        if (existing) existing.dispose();

        const pop = new bootstrap.Popover(el, {
            trigger: "manual",
            html: true,
            // helps if Safari is clipping it inside overflow-hidden navs/offcanvas
            container: "body",
        });

        el.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();

            const isOpen = !!el.getAttribute("aria-describedby");
            if (isOpen) {
                pop.hide();
                (el as HTMLElement).blur();
            } else {
                pop.show();
            }
        });
    });

    // click/tap outside closes any open popovers
    document.addEventListener("click", (e) => {
        document
            .querySelectorAll('[data-bs-toggle="popover"]')
            .forEach((el) => {
                const instance = bootstrap.Popover.getInstance(el);
                if (!instance) return;

                const isOpen = !!el.getAttribute("aria-describedby");
                if (!isOpen) return;

                const describedById = el.getAttribute("aria-describedby");
                const popoverEl = describedById
                    ? document.getElementById(describedById)
                    : null;

                const clickedInsideTrigger = e.target
                    ? el.contains(e.target as Node)
                    : false;
                const clickedInsidePopover = e.target
                    ? (popoverEl?.contains(e.target as Node) ?? false)
                    : false;

                if (!clickedInsideTrigger && !clickedInsidePopover) {
                    instance.hide();
                    (el as HTMLElement).blur();
                }
            });
    });

    // Close on scroll + blur if open
    window.addEventListener(
        "scroll",
        () => {
            document
                .querySelectorAll('[data-bs-toggle="popover"]')
                .forEach((el) => {
                    const instance = bootstrap.Popover.getInstance(el);
                    if (!instance) return;

                    if (el.getAttribute("aria-describedby")) {
                        instance.hide();
                        if (document.activeElement === el)
                            (el as HTMLElement).blur();
                    }
                });
        },
        { passive: true },
    );
}
